/**
 * @file 订单进行态
 */
import { useState, ReactNode, useEffect, useRef } from 'react';
import { useFm } from '@web3/base-hooks';
import dayjs from 'dayjs';

import styles from './index.module.scss';
import ProcessIcon from '@/assets/images/stake-progress.svg';

interface Props {
  finishTime: number;
  children: ReactNode;
}

export const OrderResultPending = (props: Props) => {
  const { finishTime, children } = props;
  const fm = useFm();
  const [selfFinishTime, setSelfFinishTime] = useState(0);
  const timer = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (!+finishTime) return;

    setSelfFinishTime(finishTime);
  }, [finishTime]);

  // 倒计时，当倒计时到1s时，重新开启新一轮的倒计时
  useEffect(() => {
    if (!+selfFinishTime) return;

    let newFinishTime = 0;
    if (selfFinishTime > 0) {
      newFinishTime = selfFinishTime - 1;
    }
    if (selfFinishTime === 1) {
      newFinishTime = finishTime;
    }

    timer.current = setTimeout(() => {
      setSelfFinishTime(newFinishTime);
    }, 1000);

    return () => {
      clearTimeout(timer.current);
    };
  }, [selfFinishTime]);

  return (
    <div className={styles.container}>
      <div className={styles.status}>
        <ProcessIcon className={styles.processIcon} />
        <div className={styles.title}>{fm('pending')}</div>
        <div className={styles.desc}>
          {fm('estimatedCompletionTime', {
            time: (
              <span className={styles.time}>
                {+finishTime
                  ? dayjs()
                      .startOf('day')
                      .add(selfFinishTime || 0, 'second')
                      .format('mm:ss')
                  : '--'}
              </span>
            ),
          })}
        </div>
      </div>
      {children}
    </div>
  );
};
